/** *****************************************************************************
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2020, 2024. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 ****************************************************************************** */
import React from "react";
export function ErrorMessage(props) {
  if (!props.error) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "cds--form-requirement"
  }, props.error);
}
export function WarningMessage(props) {
  if (!props.warning) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "cds--form-requirement cds--form-warning"
  }, props.warning);
}
export function InfoMessage(props) {
  if (!props.info) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "cds--form-requirement cds--form-info"
  }, props.info);
}